/* eslint-disable */
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import "../styles/Calibration.css";
import Swal from "sweetalert2";
import Draggable from "react-draggable";
import axios from "axios";
import { Context } from "../services/Context";

const Calibration = ({ setOpenModal, webcamRef, userEmail }) => {
  const { urlVision, currentCalibration, calibrationBackground, translate } = useContext(Context);
  const calibration = useRef(null);
  const [stains, setStains] = useState(null);
  const [calibrated, setCalibrated] = useState(false);
  const [imgSrc, setImgSrc] = useState(null);
  const [correctCalibration, setCorrectCalibration] = useState(true);
  const [currentMark, setCurrentMark] = useState(1);
  const calibrationImageRef = useRef(null);
  const [semiAutoCalibration, setSemiAutoCalibration] = useState(false);
  const [currentMessage, setCurrentMessage] = useState(
    "Intentando calibración automática"
  );
  const [proportions, setProportions] = useState({ width: null, height: null });
  const calib_measures = useRef({ calib_h: 0, calib_w: 0 });
  const [calibrationMode, setCalibrationMode] = useState(null); // null = menu, 'auto' = automática, 'manual' = manual, 'file' = cargar archivo

  const autoCalibration = async () => {
    setCalibrationMode('auto');
    setCurrentMessage('Intentando calibración automática');
    
    // Capture screenshot from webcam
    const imgTemp = webcamRef?.current?.getScreenshot?.();
    
    // Validate screenshot before sending to prevent server-side OpenCV empty matrix errors
    if (!imgTemp || typeof imgTemp !== "string" || imgTemp.length < 100 || !imgTemp.startsWith("data:image")) {
      Swal.fire({
        icon: "error",
        title: "Error de Cámara",
        text: "No se pudo capturar la imagen de la cámara. Verifique que la cámara esté conectada y con permisos activados.",
        confirmButtonText: "Entendido"
      });
      setCalibrationMode(null);
      return;
    }

    setImgSrc(imgTemp);

    const payload = {
      Screenshot: imgTemp,
    };


    try {
      const response = await axios.post(`${urlVision}calibration_automatic`, payload, {
        timeout: 30000,
        headers: {
          'Content-Type': 'application/json'
        }
      });

      calib_measures.current = {
        calib_h: response.data.response.calib_h,
        calib_w: response.data.response.calib_w,
      };
      setCalibrated(true);
      calibration.current = response.data;
      setTimeout(() => setStains(response.data.response.points), [0]);

    } catch (err) {
      if (err.response) {
        // Server responded with error status
        const statusCode = err.response.status;
        let errorMessage = "Error en el servidor de calibración.";
        
        if (statusCode === 502 || statusCode === 503) {
          errorMessage = "El servicio de calibración no está disponible. Por favor, contacte al administrador o intente más tarde.";
        } else if (statusCode === 400) {
          errorMessage = err.response.data?.message || "La imagen enviada no es válida para calibración.";
        } else if (statusCode >= 500) {
          errorMessage = "Error interno en el servidor de calibración. Contacte al administrador.";
        }

        Swal.fire({
          icon: "error",
          title: `Error ${statusCode}`,
          text: errorMessage,
          footer: err.response.data?.detail || ""
        });
      } else if (err.request) {
        // Request made but no response received
        Swal.fire({
          icon: "error",
          title: "Sin Respuesta",
          text: "No se recibió respuesta del servidor de calibración. Verifique su conexión a internet.",
        });
      } else {
        // Something else happened
        Swal.fire({
          icon: "error",
          title: "Error Inesperado",
          text: "Error al preparar la solicitud de calibración. Intente nuevamente.",
        });
      }
      
      // Resetear el estado para mostrar el menú inicial
      setCalibrated(false);
      setCalibrationMode(null);
      setCurrentMessage("Seleccione el modo de calibración");
    }
  };

  const startManualCalibration = () => {
    setCalibrationMode('manual');
    setCurrentMessage('Configurando calibración manual');
    
    // Capturar imagen de la cámara
    const imgTemp = webcamRef?.current?.getScreenshot?.();
    
    if (!imgTemp || typeof imgTemp !== "string" || imgTemp.length < 100 || !imgTemp.startsWith("data:image")) {
      Swal.fire({
        icon: "error",
        title: "Error de Cámara",
        text: "No se pudo capturar la imagen de la cámara. Use la opción de cargar archivo.",
        confirmButtonText: "Entendido"
      });
      setCalibrationMode(null);
      return;
    }
    
    setImgSrc(imgTemp);
    calib_measures.current = { calib_h: 720, calib_w: 1280 };
    
    // Crear marcas por defecto en coordenadas normalizadas
    const defaultStains = [
      { x: 0.1, y: 0.1, z: 1 },
      { x: 0.9, y: 0.1, z: 2 },
      { x: 0.1, y: 0.9, z: 3 },
      { x: 0.9, y: 0.9, z: 4 },
      { x: 0.5, y: 0.5, z: 5 },
      { x: 0.5, y: 0.1, z: 6 },
    ];
    
    setStains(defaultStains);
    setCalibrated(true);
    setCorrectCalibration(false);
    setCurrentMark(1);
    
    // Calcular proporciones después de que se renderice el SVG
    setTimeout(() => {
      const container = document.getElementById("StainsContainer");
      if (container) {
        const containerWidth = container.clientWidth;
        const containerHeight = container.clientHeight;
        const calibW = calib_measures.current.calib_w;
        const calibH = calib_measures.current.calib_h;
        
        setProportions({
          width: containerWidth / calibW,
          height: containerHeight / calibH,
        });
      }
    }, 100);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    
    setCalibrationMode('file');
    setCurrentMessage("Cargando imagen desde archivo...");
    
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result;
      
      // Normalizar formato a JPEG
      let normalizedScreenshot = base64String;
      const dataUrlMatch = base64String.match(/^data:image\/(\w+);base64,/);
      if (dataUrlMatch && dataUrlMatch[1] !== 'jpeg') {
        const currentPrefix = dataUrlMatch[0];
        const base64Data = base64String.substring(currentPrefix.length);
        normalizedScreenshot = `data:image/jpeg;base64,${base64Data}`;
      }
      
      setImgSrc(normalizedScreenshot);
      calib_measures.current = { calib_h: 720, calib_w: 1280 };
      
      // Preguntar qué tipo de calibración hacer
      Swal.fire({
        icon: "question",
        title: "Imagen Cargada",
        text: `Archivo "${file.name}" cargado. ¿Qué tipo de calibración desea?`,
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: '🤖 Automática',
        denyButtonText: '✋ Manual',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#4CAF50',
        denyButtonColor: '#2196F3',
        cancelButtonColor: '#f44336'
      }).then(async (result) => {
        if (result.isConfirmed) {
          // Intentar calibración automática con la imagen
          setCurrentMessage('Procesando calibración automática...');
          try {
            const response = await axios.post(`${urlVision}calibration_automatic`, 
              { Screenshot: normalizedScreenshot },
              { timeout: 30000, headers: { 'Content-Type': 'application/json' } }
            );
            
            calib_measures.current = {
              calib_h: response.data.response.calib_h,
              calib_w: response.data.response.calib_w,
            };
            setCalibrated(true);
            calibration.current = response.data;
            setTimeout(() => setStains(response.data.response.points), 0);
          } catch (err) {
            Swal.fire({
              icon: "error",
              title: "Error en Calibración Automática",
              text: "No se pudo procesar automáticamente. Intente con calibración manual.",
            });
            setCalibrationMode(null);
          }
        } else if (result.isDenied) {
          // Calibración manual con la imagen cargada
          const defaultStains = [
            { x: 0.1, y: 0.1, z: 1 },
            { x: 0.9, y: 0.1, z: 2 },
            { x: 0.1, y: 0.9, z: 3 },
            { x: 0.9, y: 0.9, z: 4 },
            { x: 0.5, y: 0.5, z: 5 },
            { x: 0.5, y: 0.1, z: 6 },
          ];
          
          setStains(defaultStains);
          setCalibrated(true);
          setCorrectCalibration(false);
          setCurrentMark(1);
          
          setTimeout(() => {
            const container = document.getElementById("StainsContainer");
            if (container) {
              setProportions({
                width: container.clientWidth / calib_measures.current.calib_w,
                height: container.clientHeight / calib_measures.current.calib_h,
              });
            }
          }, 100);
        } else {
          setCalibrationMode(null);
        }
      });
    };
    
    reader.readAsDataURL(file);
  };

  const handleDrag = (index, data) => {
    const svgContainer = document.getElementById("StainsContainer");
    if (!svgContainer) return;
    
    const svgRect = svgContainer.getBoundingClientRect();
    
    // data.x y data.y son las posiciones absolutas en el SVG después del drag
    const { x, y } = data;
    
    // Obtener dimensiones de calibración
    const calibW = calib_measures.current.calib_w;
    const calibH = calib_measures.current.calib_h;
    
    // Convertir de píxeles del SVG a píxeles de la imagen
    const imageX = (x / svgRect.width) * calibW;
    const imageY = (y / svgRect.height) * calibH;
    
    // Actualizar la posición de la marca
    const updatedStains = [...stains];
    updatedStains[index] = {
      ...updatedStains[index],
      x: imageX,
      y: imageY,
    };
    
    console.log(`🎯 Marca ${index + 1} arrastrada:`, {
      svgPosition: { x: x.toFixed(1), y: y.toFixed(1) },
      imagePixels: { x: imageX.toFixed(1), y: imageY.toFixed(1) },
      svgRect: { width: svgRect.width, height: svgRect.height },
      calibDimensions: { width: calibW, height: calibH }
    });
    
    setStains(updatedStains);
  };
  
  const handleDragStop = (index) => {
    console.log(`✅ Marca ${index + 1} posicionada en:`, stains[index]);
  };

  const manualCalibration = async () => {
    setSemiAutoCalibration(true);
    
    // Validate imgSrc before processing
    if (!imgSrc || typeof imgSrc !== "string" || imgSrc.length < 100 || !imgSrc.startsWith("data:image")) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No hay imagen válida para calibración. Intente realizar la calibración automática primero.",
      });
      setSemiAutoCalibration(false);
      return;
    }

    // Obtener dimensiones de calibración
    const calibW = calib_measures.current.calib_w;
    const calibH = calib_measures.current.calib_h;
    
    // Las marcas en stains[] ya están en píxeles absolutos desde handleDrag
    const centros = stains.map((stain, i) => ({
      x: parseFloat(stain.x.toFixed(2)), 
      y: parseFloat(stain.y.toFixed(2))
    }));

    console.log("🔍 Marcas para calibración semi-automática:", {
      centrosCalculados: centros.length,
      centros: centros,
      calibW: calibW,
      calibH: calibH,
      note: "Coordenadas en píxeles absolutos de la imagen",
      currentStains: stains
    });

    // Validate marks - DEBE HABER EXACTAMENTE 6
    if (!centros || centros.length !== 6) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: `Se detectaron ${centros.length} marcas. Deben ser exactamente 6 marcas de calibración.`,
      });
      setSemiAutoCalibration(false);
      return;
    }

    // Validate that all coordinates are valid numbers
    const invalidMarks = centros.filter((c, i) => 
      !isFinite(c.x) || !isFinite(c.y) || isNaN(c.x) || isNaN(c.y)
    );
    
    if (invalidMarks.length > 0) {
      Swal.fire({
        icon: "error",
        title: "Error de Coordenadas",
        text: `Se detectaron ${invalidMarks.length} marcas con coordenadas inválidas (NaN o Infinity). Verifique las proporciones de la imagen.`,
      });
      setSemiAutoCalibration(false);
      return;
    }

    // Check for marks outside pixel range [0, calibW] and [0, calibH]
    const outOfRangeMarks = centros.filter((c, i) => 
      c.x < 0 || c.x > calibW || c.y < 0 || c.y > calibH
    );
    
    if (outOfRangeMarks.length > 0) {
      console.error("❌ Marcas fuera de los límites de la imagen:", {
        outOfRangeMarks,
        allMarks: centros,
        validRange: `[0 - ${calibW}] x [0 - ${calibH}] píxeles`
      });
      
      Swal.fire({
        icon: "error",
        title: "Marcas fuera de límites",
        text: `${outOfRangeMarks.length} marca(s) están fuera de la imagen. Asegúrese de que todas las marcas estén dentro del área visible de la cámara.`,
        footer: `Rango válido: X entre 0 y ${calibW}, Y entre 0 y ${calibH} píxeles`
      });
      setSemiAutoCalibration(false);
      return;
    }

    const payload = {
      Screenshot: imgSrc,
      marks: centros,
    };

    console.log("� Enviando calibración semi-automática:", {
      url: `${urlVision}calibration_semiautomatic`,
      screenshotLength: imgSrc.length,
      marksCount: centros.length,
      marksDetails: centros.map((m, i) => ({
        mark: i + 1,
        x: m.x,
        y: m.y,
        isValid: !isNaN(m.x) && !isNaN(m.y) && isFinite(m.x) && isFinite(m.y),
        inRange: m.x >= 0 && m.x <= calibW && m.y >= 0 && m.y <= calibH
      })),
      calibDimensions: { width: calibW, height: calibH }
    });

    try {
      const response = await axios.post(`${urlVision}calibration_semiautomatic`, payload, {
        timeout: 30000,
        headers: {
          'Content-Type': 'application/json'
        }
      });

      console.log("✅ Respuesta de calibración semi-automática:", response.data);

      setCurrentMark(1);
      setCorrectCalibration(true);
      calibration.current = response.data;
      setTimeout(() => setStains(response.data.response.points), [0]);
      setSemiAutoCalibration(false);

    } catch (err) {
      console.error("❌ Error en calibración semi-automática:", {
        message: err.message,
        status: err.response?.status,
        data: err.response?.data
      });

      if (err.response) {
        const statusCode = err.response.status;
        let errorMessage = "Error al procesar la calibración manual.";
        
        if (statusCode === 502 || statusCode === 503) {
          errorMessage = "El servicio de calibración no está disponible. Contacte al administrador.";
        } else if (statusCode === 400) {
          errorMessage = err.response.data?.message || "Los datos de calibración no son válidos.";
        }

        Swal.fire({
          icon: "error",
          title: `Error ${statusCode}`,
          text: errorMessage,
        });
      } else if (err.request) {
        Swal.fire({
          icon: "error",
          title: "Sin Respuesta",
          text: "No se recibió respuesta del servidor. Verifique su conexión.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error Inesperado",
          text: "Error al preparar la solicitud. Intente nuevamente.",
        });
      }
      setSemiAutoCalibration(false);
    }
  };

  const saveCalibration = () => {
    setTimeout(() => {
      setCalibrated(false);
      setCurrentMessage("Guardando calibración");
    }, [0]);
    currentCalibration.current = calibration.current;
    calibrationBackground.current = imgSrc;
    setTimeout(() => {
      document.getElementById("messageState").innerHTML = "Calibración Guardada";
    }, [1000]);
    document.getElementById("CloseCalibrationModal").setAttribute("disabled", "true");
    setTimeout(() => document.getElementById("myModal").click(), [1000]);
  };

  useEffect(() => {
    document.addEventListener("click", (e) => {
      if (document.getElementById("myModal") == e.target) {
        setOpenModal(false);
      }
    });
    
    // Recalcular proporciones cuando cambia el tamaño de la ventana
    const handleResize = () => {
      if (calibrated && !correctCalibration) {
        const container = document.getElementById("StainsContainer");
        if (container) {
          const containerWidth = container.clientWidth;
          const containerHeight = container.clientHeight;
          const calibW = calib_measures.current.calib_w;
          const calibH = calib_measures.current.calib_h;
          
          setProportions({
            width: containerWidth / calibW,
            height: containerHeight / calibH,
          });
        }
      }
    };
    
    window.addEventListener("resize", handleResize);
    
    // NO iniciar automáticamente, mostrar menú de selección
    
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [calibrated, correctCalibration]);

  return (
    <>
      <input
        type="file"
        id="imageUploadInput"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={handleFileUpload}
      />
      <div id="myModal" className="calibrationModal">
        <div className="calibrationModalContent">
          <span
            className="calibrationModalClose"
            id='CloseCalibrationModal'
            onClick={() => setOpenModal(false)}
          >
            &times;
          </span>
          <p className="calibrationModalTitle">{"Calibración"}</p>
          <div
            id="calibrationModalContainer"
            className="calibrationModalContainer"
          >
            {calibrated ? (
              <>
                <div className="calibrationModalImage">
                  <img
                    style={{ height: "100%", width: "100%" }}
                    ref={calibrationImageRef}
                    src={imgSrc}
                  />
                  {correctCalibration ? (
                    <svg
                      id="StainsContainer"
                      height="100%"
                      width="100%"
                      style={{ marginLeft: "-100%" }}
                    >
                      {stains &&
                        stains.map((stain, index) => {
                          if (
                            proportions.width === null &&
                            proportions.height === null
                          ) {
                            const containerWidth = document.getElementById("StainsContainer").clientWidth;
                            const containerHeight = document.getElementById("StainsContainer").clientHeight;
                            const calibW = calib_measures.current.calib_w;
                            const calibH = calib_measures.current.calib_h;
                            
                            const newProportions = {
                              width: containerWidth / calibW,
                              height: containerHeight / calibH,
                            };
                            
                            setProportions(newProportions);
                          }
                          return (
                            <g key={`g ${index}`}>
                              {stain.contorno && (
                                <polygon
                                  key={`p ${index}`}
                                  points={stain.contorno
                                    .map(
                                      (point) =>
                                        `${point.x * proportions.width},${
                                          point.y * proportions.height
                                        }`
                                    )
                                    .join(" ")}
                                  style={{ fill: "#00F545", opacity: 0.6 }}
                                />
                              )}
                              <text
                                key={`t ${index}`}
                                style={{ userSelect: "none" }}
                                x={(stain.x - 5) * proportions.width}
                                y={(stain.y + 5) * proportions.height}
                                fontFamily="Verdana"
                                fontSize="11"
                                fontWeight={"bold"}
                                fill="#F50000"
                              >
                                {stain.z}
                              </text>
                            </g>
                          );
                        })}
                    </svg>
                  ) : (
                    <svg
                      id="StainsContainer"
                      height="100%"
                      width="100%"
                      style={{ marginLeft: "-100%" }}
                    >
                      {stains &&
                        stains.slice(0, currentMark).map((stain, index) => {
                          // stain.x y stain.y están en píxeles de la imagen (0-1280, 0-720)
                          // Convertir a píxeles del SVG para renderizar
                          const calibW = calib_measures.current.calib_w;
                          const calibH = calib_measures.current.calib_h;
                          
                          const svgX = (stain.x / calibW) * (proportions.width * calibW);
                          const svgY = (stain.y / calibH) * (proportions.height * calibH);
                          
                          return (
                          <Draggable
                            key={`draggable-${index}`}
                            onStop={(e, data) => handleDrag(index, data)}
                            bounds={document.getElementById("StainsContainer")}
                            position={{ x: svgX, y: svgY }}
                          >
                            <g key={`g ${index}`}>
                              <circle
                                key={`cm ${index}`}
                                cx={0}
                                cy={0}
                                r={12}
                                fill="#00F545"
                                style={{ opacity: 0.4, cursor: 'move' }}
                              />
                              <text
                                key={`t ${index}`}
                                style={{ userSelect: "none", pointerEvents: "none" }}
                                x={5}
                                y={-15}
                                fontFamily="Verdana"
                                fontSize="12"
                                fontWeight={"bold"}
                                fill="#F50000"
                              >
                                {index + 1}
                              </text>
                              <circle
                                key={`c ${index}`}
                                id={index + 1}
                                cx={0}
                                cy={0}
                                r={1}
                                fill="red"
                              />
                            </g>
                          </Draggable>
                        )})}
                    </svg>
                  )}
                </div>
                <div className="calibrationModalActions">
                  {correctCalibration ? (
                    <>
                      <p className="calibrationModalQuestion">
                        {"¿Puede apreciar en la imagen de la cámara una calibración como la imagen de ejemplo?"}
                      </p>
                      <img
                        src="assets/calibrations/calibration-example.png"
                        style={{
                          height: "auto",
                          width: "auto",
                          maxHeight: "80%",
                          border: "0.5px solid #000",
                        }}
                      />
                      <div className="calibrationModalButtonsActions">
                        <button
                          className="calibrationModalButtonNo"
                          onClick={() => {
                            setCorrectCalibration(false);
                            // Recalcular proporciones al cambiar a modo manual
                            setTimeout(() => {
                              const container = document.getElementById("StainsContainer");
                              if (container) {
                                const containerWidth = container.clientWidth;
                                const containerHeight = container.clientHeight;
                                const calibW = calib_measures.current.calib_w;
                                const calibH = calib_measures.current.calib_h;
                                
                                setProportions({
                                  width: containerWidth / calibW,
                                  height: containerHeight / calibH,
                                });
                              }
                            }, 100);
                          }}
                        >
                          {"No"}
                        </button>
                        <button
                          className="calibrationModalButtonYes"
                          onClick={() => saveCalibration()}
                        >
                          {"Si"}
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <p className="calibrationModalQuestion">
                        {"Selección Manual de las marcas en la imagen"}
                      </p>
                      <img
                        src={`assets/calibrations/calibration-mark-${currentMark}.png`}
                        style={{
                          height: "auto",
                          width: "auto",
                          maxHeight: "80%",
                          justifySelf: "center",
                          border: "0.5px solid #000",
                        }}
                      />
                      <div>
                        <p style={{ lineHeight: "0.5em" }}>
                          {"En la imagen de la cámara, arrastre la ubicación de la marca"} {currentMark}{" "}
                        </p>
                      </div>
                      <div className="calibrationModalButtonsManual">
                        <button
                          className="calibrationModalButtonCancel"
                          onClick={() => setCorrectCalibration(true)}
                        >
                          {"Cancelar"}
                        </button>
                        <button
                          className="calibrationModalButtonPrevMark"
                          disabled={currentMark === 1}
                          onClick={() => setCurrentMark(currentMark - 1)}
                        >
                          {"Marca Anterior"}
                        </button>
                        <button
                          className="calibrationModalButtonNextMark"
                          disabled={currentMark === 6}
                          onClick={() => setCurrentMark(currentMark + 1)}
                        >
                          {"Siguiente Marca"}
                        </button>
                        <button
                          className="calibrationModalButtonTryCalibration"
                          disabled={currentMark !== 6}
                          onClick={() => manualCalibration()}
                        >
                          {semiAutoCalibration ? (
                            <svg
                              width="40"
                              height="40"
                              stroke="#fff"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g className="spinner_V8m1">
                                <circle
                                  cx="12"
                                  cy="12"
                                  r="9.5"
                                  fill="none"
                                  stroke-width="3"
                                ></circle>
                              </g>
                            </svg>
                          ) : (
                            "Intentar Calibracion Semi-Automatica"
                          )}
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </>
            ) : (
              <>
                {calibrationMode === null ? (
                  // Menú de selección de modo de calibración
                  <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    gap: '2rem',
                    padding: '3rem 2rem'
                  }}>
                    <h2 style={{ color: '#fff', marginBottom: '1rem', textAlign: 'center' }}>
                      Seleccione el Modo de Calibración
                    </h2>
                    
                    <button
                      style={{
                        padding: '1.5rem 3rem',
                        fontSize: '1.2rem',
                        backgroundColor: '#4CAF50',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        minWidth: '350px',
                        fontWeight: 'bold',
                        transition: 'all 0.3s',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.3)'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#45a049';
                        e.target.style.transform = 'translateY(-2px)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#4CAF50';
                        e.target.style.transform = 'translateY(0)';
                      }}
                      onClick={() => autoCalibration()}
                    >
                      🤖 Calibración Automática
                      <div style={{ fontSize: '0.8rem', fontWeight: 'normal', marginTop: '0.5rem' }}>
                        Detecta automáticamente las marcas de calibración
                      </div>
                    </button>

                    <button
                      style={{
                        padding: '1.5rem 3rem',
                        fontSize: '1.2rem',
                        backgroundColor: '#2196F3',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        minWidth: '350px',
                        fontWeight: 'bold',
                        transition: 'all 0.3s',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.3)'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#0b7dda';
                        e.target.style.transform = 'translateY(-2px)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#2196F3';
                        e.target.style.transform = 'translateY(0)';
                      }}
                      onClick={() => startManualCalibration()}
                    >
                      ✋ Calibración Manual
                      <div style={{ fontSize: '0.8rem', fontWeight: 'normal', marginTop: '0.5rem' }}>
                        Posiciona manualmente las 6 marcas de calibración
                      </div>
                    </button>

                    <button
                      style={{
                        padding: '1.5rem 3rem',
                        fontSize: '1.2rem',
                        backgroundColor: '#FF9800',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        minWidth: '350px',
                        fontWeight: 'bold',
                        transition: 'all 0.3s',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.3)'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#F57C00';
                        e.target.style.transform = 'translateY(-2px)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#FF9800';
                        e.target.style.transform = 'translateY(0)';
                      }}
                      onClick={() => document.getElementById('imageUploadInput')?.click()}
                    >
                      📁 Cargar Imagen de Archivo
                      <div style={{ fontSize: '0.8rem', fontWeight: 'normal', marginTop: '0.5rem' }}>
                        Sube una imagen y elige el tipo de calibración
                      </div>
                    </button>

                    <p style={{ 
                      color: '#ccc', 
                      fontSize: '0.9rem', 
                      marginTop: '1rem',
                      textAlign: 'center',
                      maxWidth: '400px',
                      lineHeight: '1.5'
                    }}>
                      💡 <strong>Recomendación:</strong> Pruebe primero la calibración automática. Si falla, puede usar la calibración manual.
                    </p>
                  </div>
                ) : (
                  // Pantalla de carga mientras se procesa
                  <>
                    <h1 id="messageState">
                      {currentMessage}
                      <svg
                        width="75"
                        height="75"
                        viewBox="0 0 24 6"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="#fff"
                        style={{ marginLeft: "1em" }}
                      >
                        <circle className="spinner_b2T7" cx="4" cy="12" r="3" />
                        <circle
                          className="spinner_b2T7 spinner_YRVV"
                          cx="12"
                          cy="12"
                          r="3"
                        />
                        <circle
                          className="spinner_b2T7 spinner_c9oY"
                          cx="20"
                          cy="12"
                          r="3"
                        />
                      </svg>
                    </h1>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Calibration;
